/**
 * useTheme — React binding for the app-wide theme store (`@/lib/theme`).
 *
 * `useSyncExternalStore` is what makes the header toggle and the Settings
 * Appearance tab stay in agreement: both read the same external value, so a
 * change made on one re-renders the other even though neither owns the state.
 */
import { useSyncExternalStore } from 'react';
import {
  getTheme,
  resolvesToDark,
  setTheme,
  subscribeToTheme,
  type ThemePreference,
} from '@/lib/theme';

export function useTheme(): {
  theme: ThemePreference;
  isDark: boolean;
  setTheme: (preference: ThemePreference) => void;
} {
  const theme = useSyncExternalStore(subscribeToTheme, getTheme, getTheme);
  return { theme, isDark: resolvesToDark(theme), setTheme };
}
